require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./partir-ltranger-2-5-0.json") })
        }
      }, "path---partir-ltranger-2-5-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---partir-ltranger-2-5-0!./.cache/json/partir-ltranger-2-5-0.json
// module id = 516
// module chunks = 231608221292675